import { Injectable } from '@angular/core';
import firebase from 'firebase/compat/app';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { BehaviorSubject, Observable } from 'rxjs';
import { CloudFunctionsService } from '../core/cloud-functions.service';
import { map } from 'rxjs/operators';

export enum SiteAdminErrors {
  permissionDenied = 'permissionDenied'
}

@Injectable({
  providedIn: 'root'
})
export class UserService {

  firebaseUser: Observable<firebase.User | null>;
  siteAdmin: BehaviorSubject<SiteAdmin | null>;

  public isInitialized = false;
  public isLoggedIn = false;
  public siteAdminError: SiteAdminErrors | null = null;

  constructor(
    public auth: AngularFireAuth,
    private fs: CloudFunctionsService) {
    this.firebaseUser = this.auth.user;
  }

  getUser(): Observable<firebase.User | null> {
    return this.firebaseUser;
  }

  getSiteAdmin(): Observable<SiteAdmin | null> {
    if (this.siteAdmin == null) {
      this.siteAdmin = new BehaviorSubject<SiteAdmin | null>(null);
      this.getUser().subscribe(user => {
        this.isLoggedIn = user != null;
        this.siteAdminError = null;
        if (user != null) {
          this.fs.functions.httpsCallable('getAdminUser')(null)
            .subscribe({
              next: data => {
                this.isInitialized = true;
                const siteAdmin = (data as any).siteAdmin as SiteAdmin;
                this.siteAdmin.next(siteAdmin);
              },
              error: err => {
                this.isInitialized = true;
                if (err.code === 'permission-denied' || err.code === 'functions/permission-denied') {
                  this.siteAdminError = SiteAdminErrors.permissionDenied;
                  this.siteAdmin.next(null);
                } else {
                  console.error(err);
                }
              }
            });
        } else {
          this.isInitialized = true;
          this.siteAdmin.next(null);
        }
      });
    }
    return this.siteAdmin;
  }

  isSiteAdmin(): Observable<boolean> {
    return this.getSiteAdmin().pipe(map(siteAdmin => siteAdmin != null));
  }
}

class SiteAdmin {
  constructor(public root: boolean) { }
}
